import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import {
  ActivityComponent,
  BladeComponent,
  BreadcrumbComponent,
  ConfirmationModalComponent,
  LayoutComponent,
  MegaMenuComponent,
  MessagesComponent,
  NavigationComponent,
  NotFoundComponent,
  NotificationsComponent,
  SearchComponent,
  SettingsComponent,
  SidebarComponent,
  SpinnerComponent,
} from './components';

@NgModule({
  declarations: [
    ActivityComponent,
    BladeComponent,
    BreadcrumbComponent,
    LayoutComponent,
    MegaMenuComponent,
    MessagesComponent,
    NavigationComponent,
    NotFoundComponent,
    NotificationsComponent,
    SearchComponent,
    SettingsComponent,
    SidebarComponent,
    SpinnerComponent,
    ConfirmationModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgbModule,
    PerfectScrollbarModule,
  ],
  exports: [
    LayoutComponent,
    MegaMenuComponent,
    MessagesComponent,
    NgbModule,
    NotificationsComponent,
    SearchComponent,
    SpinnerComponent,
    ConfirmationModalComponent,
  ],
})
export class LayoutModule {}
